import tippy, { followCursor } from 'tippy.js';
import confetti from 'canvas-confetti';
import Command from '../general/Command';

let cameraFeedEnabled = true;
let cameraMuted = true;

let manager;

// when this variable is set to true the host_mute_video action is not going to be executed
// and then it MUST be changed to false
window.cancelShowViewportPlaceholder = false;

const hostMutedCommand = new Command('host_muted_video', (data) => {
  // defer a bit to be able to cancel this action if its not necessary
  window.setTimeout(() => {
    if (window.cancelShowViewportPlaceholder) {
      window.cancelShowViewportPlaceholder = false;
      return;
    }
    $('#viewportPlaceholderText').toggleClass('hidden', data.args.cameraEnabled);
  }, 200);
});

const fireworksCommand = new Command('show_fireworks', showFireworks);

function setupVideoSizeListeners() {
  const localVideo = document.querySelector('#localVideo');
  if (localVideo !== null) {
	  localVideo.addEventListener('resize', () => {
		 tippy('#videoWrapper', {
        content: `Source: ${localVideo.videoWidth}x${localVideo.videoHeight}`,
        followCursor: true,
        plugins: [followCursor],
		 });
	  });
  }

  const remoteVideo = document.querySelector('#remoteVideo');
  if (remoteVideo !== null) {
	  remoteVideo.addEventListener('resize', () => {
		 console.log(`resize: Remote video size changed to ${remoteVideo.videoWidth} x ${remoteVideo.videoHeight}`);
	  });
  }
}

function muteVideoFeed() {
  if ($(this).data('id') === 'camera') {
	  muteCameraVideo(!cameraFeedEnabled);
  }
}

function muteCameraVideo(enable) {
  cameraFeedEnabled = enable;
  hostMutedCommand.sendAll({ cameraEnabled: cameraFeedEnabled });
  manager.toggleCameraVideo(cameraFeedEnabled);
}

function toggleFullscreen(event) {
  let elem = document.getElementById('remoteVideo');
  if ($(event.target).data('id') != null) elem = document.getElementById(`remoteVideo${$(event.target).data('id')}`);

  const fullscreen = elem.webkitRequestFullscreen || elem.mozRequestFullScreen || elem.msRequestFullscreen;
  fullscreen.call(elem); // bind the 'this' from the video object and instantiate the correct fullscreen method.
}

function showFireworks() {
  const duration = 15 * 1000;
  const defaults = {
	  startVelocity: 30, spread: 360, ticks: 60, zIndex: 0,
  };
  $('#martiniShotSound')[0].play();

  function randomInRange(min, max) {
	  return Math.random() * (max - min) + min;
  }

  window.setTimeout(() => {
	  const animationEnd = Date.now() + duration;
	  const interval = setInterval(() => {
		 const timeLeft = animationEnd - Date.now();

		 if (timeLeft <= 0) {
        return clearInterval(interval);
		 }

		 const particleCount = 50 * (timeLeft / duration);

		 // since particles fall down, start a bit higher than random
		 confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
		 confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
	  }, 250);
  }, 5000);
}

// @NotUsed
function goFullscreen() {
  const elem = document.getElementById('remoteVideo');
  console.log('SET FULLSCREEN', elem);
  const fullscreen = elem.webkitRequestFullscreen || elem.mozRequestFullScreen || elem.msRequestFullscreen;
  fullscreen.call(elem); // bind the 'this' from the video object and instantiate the correct fullscreen method.
}

function setupUI(commandsManager, _manager) {
  manager = _manager;
  $('#martini').click(() => {
    fireworksCommand.sendAll();
    showFireworks();
  });
  $('.toggleFullscreen').click(toggleFullscreen);
  $('#muteVideoFeed').click(muteVideoFeed);

  setupVideoSizeListeners();

  $('#toggleContinuity').click(function () {
    if ($(this).text() == 'Continuity') {
      $(this).html('Settings');
    } else {
      $(this).html('Continuity');
    }
    $('#continuityBoardDropdown').toggleClass('hidden');
  });

  $('#togglePrivateRoom input').on('change', (e) => {
    try {
      // Send message to server
      manager.togglePrivateRoom(e.currentTarget.checked);
    } catch (error) {
      console.error('Error activating private room', e, error);
      e.currentTarget.checked = !e.currentTarget.checked;
    }
  });

  $('#toggleDirectorToSet input').on('change', (e) => {
    manager.toggleDirectorToSet(e.currentTarget.checked);
  });

  $(document).on('click', '.muteMicrophone', function () {
    console.log("Muting microphone from mirror ui")
    if ($(this).data('id') === 'camera') {
      manager.toggleCameraAudio(cameraMuted);
      cameraMuted = !cameraMuted;
    }
  });

  // commands
  commandsManager
    // @ NotUsed
    .registerNewCommand('set_fullscreen', goFullscreen)
    .registerCommand(fireworksCommand)
    .registerCommand(hostMutedCommand);
}

export { setupUI };
